module.exports = __webpack_public_path__ + "static/media/Fullissue.605a5276.PNG";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/Fullissue.PNG
// module id = 1641
// module chunks = 1